"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var idm_frontend_shared_1 = require("@synisys/idm-frontend-shared");
var operators_1 = require("rxjs/operators");
var noop_1 = require("rxjs/util/noop");
var from_1 = require("rxjs/observable/from");
var FormSettingsModel = /** @class */ (function () {
    function FormSettingsModel() {
        this.withDeleteButton = true;
        this.withEditButton = true;
        this.withCommentButton = false;
        this.userHelpItems = [];
    }
    FormSettingsModel.prototype.toJS = function () {
        return {
            userHelpItems: this.userHelpItems
                .filter(function (userHelpItem) {
                return !!userHelpItem.title ||
                    !!userHelpItem.url ||
                    (!!userHelpItem.documentId &&
                        userHelpItem.documentId !== -1);
            })
                .map(function (userHelpItem) { return ({
                title: idm_frontend_shared_1.createObjectFromMultilingualString(userHelpItem.title),
                url: userHelpItem.url,
                documentId: userHelpItem.documentId,
            }); }),
            withDeleteButton: this.withDeleteButton,
            withEditButton: this.withEditButton,
            withCommentButton: this.withCommentButton,
            userManualUrl: undefined,
            onlineHelpUrl: undefined,
        };
    };
    FormSettingsModel.prototype.fromJS = function (jsObject, messageService) {
        if (messageService) {
            var userManualUrl = idm_dynamic_layout_interpreter_1.getOptionalProperty(jsObject, 'userManualUrl');
            if (userManualUrl !== undefined) {
                this.addUserHelpItemWithTitle(messageService, 'de_help_user_manual', userManualUrl);
            }
            var onlineHelpUrl = idm_dynamic_layout_interpreter_1.getOptionalProperty(jsObject, 'onlineHelpUrl');
            if (onlineHelpUrl !== undefined) {
                this.addUserHelpItemWithTitle(messageService, 'de_help_online', onlineHelpUrl);
            }
        }
        var userHelpItemsObjects = idm_dynamic_layout_interpreter_1.getOptionalProperty(jsObject, 'userHelpItems', []);
        this.userHelpItems = userHelpItemsObjects.map(function (userHelpItemObject) { return ({
            title: idm_frontend_shared_1.buildMultilingualStringFromObject(userHelpItemObject['title']),
            url: userHelpItemObject['url'],
            documentId: userHelpItemObject['documentId'],
        }); });
        this.withDeleteButton = idm_dynamic_layout_interpreter_1.getOptionalProperty(jsObject, 'withDeleteButton', true);
        this.withEditButton = idm_dynamic_layout_interpreter_1.getOptionalProperty(jsObject, 'withEditButton', true);
        this.withCommentButton = idm_dynamic_layout_interpreter_1.getOptionalProperty(jsObject, 'withCommentButton', false);
    };
    FormSettingsModel.prototype.initFormDataRelatedSettings = function (formDto) {
        this.formName = idm_frontend_shared_1.buildMultilingualStringFromObject(formDto.name);
        this.formCategory = formDto.model.category;
        this.formType = formDto.type;
        this.description = idm_frontend_shared_1.buildMultilingualStringFromObject(formDto.description);
    };
    FormSettingsModel.prototype.getNameObject = function () {
        return idm_frontend_shared_1.createObjectFromMultilingualString(this.formName);
    };
    FormSettingsModel.prototype.getDescriptionObject = function () {
        return idm_frontend_shared_1.createObjectFromMultilingualString(this.description);
    };
    FormSettingsModel.prototype.getFormTypeString = function () {
        switch (this.formType) {
            case idm_dynamic_layout_interpreter_1.FormType.EDIT:
                return 'Edit';
            case idm_dynamic_layout_interpreter_1.FormType.VIEW:
                return 'View';
        }
    };
    FormSettingsModel.prototype.addUserHelpItemWithTitle = function (messageService, titleKey, url) {
        var _this = this;
        from_1.from(messageService.getDetailedMessagesByCriteria({
            keys: [titleKey],
        }))
            .pipe(operators_1.first(), operators_1.tap(function (messages) {
            if (messages.length === 0) {
                console.error("Message with key " + titleKey + " is not found");
                return;
            }
            _this.userHelpItems.push({
                title: idm_frontend_shared_1.buildMultilingualStringFromObject(messages[0].values),
                url: url,
                documentId: -1,
            });
        }))
            .subscribe(noop_1.noop, console.error);
    };
    return FormSettingsModel;
}());
exports.FormSettingsModel = FormSettingsModel;
//# sourceMappingURL=form-settings.model.js.map